
export const daewooLampProducts = [
  // ESPERO
  {
    id: 2001,
    name: 'EPO92-001A',
    category: 'DAEWOO',
    subcategory: 'Lamp',
    price: 35000,
    status: '재고있음',
    description: 'ESPERO 92-96 FOG LAMP',
    fullDescription: 'Fog lamp compatible with Daewoo Espero 1992-1996 models. Left/right specific mounting required, manufactured to OEM specifications.',
    compatibleVehicles: ['ESPERO 92-96'],
    voltage: '12V',
    partNumber: 'R:96186480 / L:96186479',
    image: 'https://public.readdy.ai/ai/img_res/acb03cee34650ea0cb4e017b5549c3d3.jpg',
    images: [
      'https://readdy.ai/api/search-image?query=car%20fog%20light%20front%20view%20on%20white%20background%20automotive%20catalog%20photography&width=800&height=1000&seq=epo92001aimg1&orientation=portrait',
    ],
    colors: ['#FFFFFF'],
    features: [
      { icon: 'ri-lightbulb-line', title: 'Clear Lighting', description: 'Enhanced fog visibility' },
      { icon: 'ri-shield-check-line', title: 'OEM Spec', description: 'Perfect compatibility' },
      { icon: 'ri-water-flash-line', title: 'Waterproof', description: 'Rain-safe design' },
      { icon: 'ri-tools-line', title: 'Easy Install', description: 'Bolt-on mounting' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=automotive%20lighting%20manufacturing%20facility%20clean%20environment%20professional%20lighting&width=1200&height=900&seq=epo92001acraft&orientation=landscape',
      story: 'High-quality fog lamp for safe night driving of Espero vehicles.',
      details: ['OEM specification', 'High-brightness lighting', 'Durable lens', 'Waterproof treated'],
    },
  },
  // TICO 96
  {
    id: 2002,
    name: 'TIC96-001A',
    category: 'DAEWOO',
    subcategory: 'Lamp',
    price: 42000,
    status: '재고있음',
    description: 'TICO 96 HEAD LAMP (YELLOW)',
    fullDescription: 'Head lamp compatible with Daewoo Tico 1996 models. Yellow type with retro style design.',
    compatibleVehicles: ['TICO 96'],
    voltage: '12V',
    partNumber: 'R:35302-781320 / L:35301-781320',
    image: 'https://readdy.ai/api/search-image?query=compact%20car%20headlamp%20yellow%20amber%20lens%20vintage%20style%20isolated%20on%20pure%20white%20background%20automotive%20lighting%20spare%20part%20catalog%20photography%20professional%20studio%20lighting&width=800&height=1000&seq=tic96001aprod&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=vintage%20car%20headlight%20yellow%20on%20white%20background%20automotive%20catalog%20photography&width=800&height=1000&seq=tic96001aimg1&orientation=portrait',
    ],
    colors: ['#FFD700'],
    features: [
      { icon: 'ri-lightbulb-line', title: 'Yellow Lens', description: 'Retro style' },
      { icon: 'ri-shield-check-line', title: 'OEM Spec', description: 'Perfect fit' },
      { icon: 'ri-eye-line', title: 'Clear Vision', description: 'Night driving safety' },
      { icon: 'ri-tools-line', title: 'Easy Install', description: 'Bolt-on mounting' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=automotive%20lamp%20assembly%20line%20clean%20factory%20professional%20lighting&width=1200&height=900&seq=tic96001acraft&orientation=landscape',
      story: 'Yellow head lamp that brings classic charm to Tico vehicles.',
      details: ['Yellow lens applied', 'OEM spec match', 'High-quality reflector', 'Heat-resistant housing'],
    },
  },
  {
    id: 2003,
    name: 'TIC96-002B',
    category: 'DAEWOO',
    subcategory: 'Lamp',
    price: 42000,
    status: '재고있음',
    description: 'TICO 96 HEAD LAMP (WHITE)',
    fullDescription: 'Head lamp compatible with Daewoo Tico 1996 models. White type with modern style design.',
    compatibleVehicles: ['TICO 96'],
    voltage: '12V',
    partNumber: 'R:35301A78B10-000 / L:35101A78B10-000',
    image: 'https://readdy.ai/api/search-image?query=compact%20car%20headlamp%20clear%20white%20lens%20modern%20style%20isolated%20on%20pure%20white%20background%20automotive%20lighting%20spare%20part%20catalog%20photography%20professional%20studio%20lighting&width=800&height=1000&seq=tic96002bprod&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=modern%20car%20headlight%20clear%20lens%20on%20white%20background%20automotive%20catalog%20photography&width=800&height=1000&seq=tic96002bimg1&orientation=portrait',
    ],
    colors: ['#FFFFFF'],
    features: [
      { icon: 'ri-lightbulb-line', title: 'White Lens', description: 'Modern style' },
      { icon: 'ri-shield-check-line', title: 'OEM Spec', description: 'Perfect fit' },
      { icon: 'ri-eye-line', title: 'Bright Lighting', description: 'Enhanced visibility' },
      { icon: 'ri-tools-line', title: 'Easy Install', description: 'Bolt-on mounting' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=automotive%20lighting%20quality%20control%20clean%20facility%20professional%20lighting&width=1200&height=900&seq=tic96002bcraft&orientation=landscape',
      story: 'White head lamp that adds a modern feel to Tico vehicles.',
      details: ['Clear white lens', 'High-efficiency reflector', 'OEM spec compliant', 'Enhanced durability'],
    },
  },
  {
    id: 2004,
    name: 'TIC96-003B',
    category: 'DAEWOO',
    subcategory: 'Lamp',
    price: 28000,
    status: '재고있음',
    description: 'TICO 96 FRONT LAMP (YELLOW)',
    fullDescription: 'Front turn signal lamp compatible with Daewoo Tico 1996 models. Yellow type providing clear signals.',
    compatibleVehicles: ['TICO 96'],
    voltage: '12V',
    partNumber: 'TIC96-003B',
    image: 'https://readdy.ai/api/search-image?query=car%20front%20turn%20signal%20lamp%20amber%20yellow%20lens%20compact%20isolated%20on%20pure%20white%20background%20automotive%20lighting%20spare%20part%20catalog%20photography%20professional%20studio%20lighting&width=800&height=1000&seq=tic96003bprod&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=turn%20signal%20light%20amber%20on%20white%20background%20automotive%20catalog%20photography&width=800&height=1000&seq=tic96003bimg1&orientation=portrait',
    ],
    colors: ['#FFD700'],
    features: [
      { icon: 'ri-lightbulb-line', title: 'Clear Signal', description: 'Safe turn indication' },
      { icon: 'ri-shield-check-line', title: 'OEM Spec', description: 'Perfect fit' },
      { icon: 'ri-eye-line', title: 'High Visibility', description: 'Day & night clear' },
      { icon: 'ri-tools-line', title: 'Easy Install', description: 'Bolt-on mounting' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=automotive%20signal%20lamp%20production%20clean%20factory%20professional%20lighting&width=1200&height=900&seq=tic96003bcraft&orientation=landscape',
      story: 'High-quality front lamp for safe turning.',
      details: ['High-brightness amber lens', 'OEM spec match', 'Fast blink response', 'Durability guaranteed'],
    },
  },
  {
    id: 2005,
    name: 'TIC96-004B',
    category: 'DAEWOO',
    subcategory: 'Lamp',
    price: 38000,
    status: '재고있음',
    description: 'TICO 96 TAIL LAMP (CRYSTAL WHITE)',
    fullDescription: 'Tail lamp compatible with Daewoo Tico 1996 models. Crystal white type with refined rear styling.',
    compatibleVehicles: ['TICO 96'],
    voltage: '12V',
    partNumber: 'TIC96-004B',
    image: 'https://readdy.ai/api/search-image?query=car%20tail%20lamp%20crystal%20clear%20white%20lens%20modern%20design%20isolated%20on%20pure%20white%20background%20automotive%20lighting%20spare%20part%20catalog%20photography%20professional%20studio%20lighting&width=800&height=1000&seq=tic96004bprod&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=crystal%20clear%20tail%20light%20on%20white%20background%20automotive%20catalog%20photography&width=800&height=1000&seq=tic96004bimg1&orientation=portrait',
    ],
    colors: ['#FFFFFF'],
    features: [
      { icon: 'ri-lightbulb-line', title: 'Crystal Design', description: 'Refined style' },
      { icon: 'ri-shield-check-line', title: 'OEM Spec', description: 'Perfect fit' },
      { icon: 'ri-eye-line', title: 'Clear Tail Light', description: 'Safe driving' },
      { icon: 'ri-tools-line', title: 'Easy Install', description: 'Bolt-on mounting' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=automotive%20tail%20lamp%20manufacturing%20clean%20facility%20professional%20lighting&width=1200&height=900&seq=tic96004bcraft&orientation=landscape',
      story: 'Crystal tail lamp that refines the rear of Tico vehicles.',
      details: ['Crystal clear lens', 'LED compatible', 'OEM spec compliant', 'Waterproof treated'],
    },
  },
  {
    id: 2006,
    name: 'TIC96-005B',
    category: 'DAEWOO',
    subcategory: 'Lamp',
    price: 38000,
    status: '재고있음',
    description: 'TICO 96 TAIL LAMP (CRYSTAL YELLOW)',
    fullDescription: 'Tail lamp compatible with Daewoo Tico 1996 models. Crystal yellow type with classic rear styling.',
    compatibleVehicles: ['TICO 96'],
    voltage: '12V',
    partNumber: 'TIC96-005B',
    image: 'https://readdy.ai/api/search-image?query=car%20tail%20lamp%20crystal%20amber%20yellow%20red%20lens%20vintage%20style%20isolated%20on%20pure%20white%20background%20automotive%20lighting%20spare%20part%20catalog%20photography%20professional%20studio%20lighting&width=800&height=1000&seq=tic96005bprod&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=amber%20tail%20light%20vintage%20on%20white%20background%20automotive%20catalog%20photography&width=800&height=1000&seq=tic96005bimg1&orientation=portrait',
    ],
    colors: ['#FFD700'],
    features: [
      { icon: 'ri-lightbulb-line', title: 'Crystal Yellow', description: 'Classic style' },
      { icon: 'ri-shield-check-line', title: 'OEM Spec', description: 'Perfect fit' },
      { icon: 'ri-eye-line', title: 'High Visibility', description: 'Safety ensured' },
      { icon: 'ri-tools-line', title: 'Easy Replace', description: 'Simple install' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=vintage%20automotive%20lamp%20production%20clean%20factory%20professional%20lighting&width=1200&height=900&seq=tic96005bcraft&orientation=landscape',
      story: 'Crystal yellow tail lamp that brings classic charm to Tico vehicles.',
      details: ['Amber crystal lens', 'Retro design', 'OEM spec match', 'Enhanced durability'],
    },
  },
  // DAMAS 05
  {
    id: 2007,
    name: 'DMS05-001',
    category: 'DAEWOO',
    subcategory: 'Lamp',
    price: 45000,
    status: '재고있음',
    description: 'DAMAS 05 HEAD LAMP',
    fullDescription: 'Head lamp compatible with Daewoo Damas 2005 models. Manufactured to OEM specifications for perfect compatibility.',
    compatibleVehicles: ['DAMAS 05'],
    voltage: '12V',
    partNumber: 'DMS05-001',
    image: 'https://readdy.ai/api/search-image?query=van%20headlamp%20clear%20lens%20chrome%20housing%20rectangular%20shape%20isolated%20on%20pure%20white%20background%20automotive%20lighting%20spare%20part%20catalog%20photography%20professional%20studio%20lighting&width=800&height=1000&seq=dms05001prod&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=van%20headlight%20front%20view%20clear%20lens%20on%20white%20background%20automotive%20catalog%20photography&width=800&height=1000&seq=dms05001img1&orientation=portrait',
    ],
    colors: ['#FFFFFF'],
    features: [
      { icon: 'ri-lightbulb-line', title: 'Clear Lighting', description: 'Night visibility enhanced' },
      { icon: 'ri-shield-check-line', title: 'OEM Spec', description: 'Perfect compatibility' },
      { icon: 'ri-water-flash-line', title: 'Waterproof', description: 'Rain-safe design' },
      { icon: 'ri-tools-line', title: 'Easy Install', description: 'Bolt-on mounting' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=automotive%20lighting%20manufacturing%20facility%20clean%20environment%20professional%20lighting&width=1200&height=900&seq=dms05001craft&orientation=landscape',
      story: 'High-quality head lamp for safe night driving of Damas 05 vehicles.',
      details: ['OEM specification', 'High-brightness lighting', 'Durable lens', 'Waterproof treated'],
    },
  },
  {
    id: 2008,
    name: 'DMS05-002',
    category: 'DAEWOO',
    subcategory: 'Lamp',
    price: 28000,
    status: '재고있음',
    description: 'DAMAS 05 FRONT LAMP',
    fullDescription: 'Front turn signal lamp compatible with Daewoo Damas 2005 models. Provides clear amber signals.',
    compatibleVehicles: ['DAMAS 05'],
    voltage: '12V',
    partNumber: 'DMS05-002',
    image: 'https://readdy.ai/api/search-image?query=van%20front%20turn%20signal%20lamp%20amber%20lens%20small%20rectangular%20isolated%20on%20pure%20white%20background%20automotive%20lighting%20spare%20part%20catalog%20photography%20professional%20studio%20lighting&width=800&height=1000&seq=dms05002prod&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=small%20van%20front%20signal%20light%20amber%20on%20white%20background%20automotive%20catalog%20photography&width=800&height=1000&seq=dms05002img1&orientation=portrait',
    ],
    colors: ['#FFD700'],
    features: [
      { icon: 'ri-lightbulb-line', title: 'Clear Signal', description: 'Safe turn indication' },
      { icon: 'ri-shield-check-line', title: 'OEM Spec', description: 'Perfect fit' },
      { icon: 'ri-eye-line', title: 'High Visibility', description: 'Day & night clear' },
      { icon: 'ri-tools-line', title: 'Easy Install', description: 'Bolt-on mounting' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=automotive%20signal%20lamp%20production%20clean%20factory%20professional%20lighting&width=1200&height=900&seq=dms05002craft&orientation=landscape',
      story: 'Front lamp for safe turning of Damas 05 vehicles.',
      details: ['High-brightness amber lens', 'OEM spec match', 'Fast blink response', 'Durability guaranteed'],
    },
  },
  {
    id: 2009,
    name: 'DMS05-003',
    category: 'DAEWOO',
    subcategory: 'Lamp',
    price: 35000,
    status: '재고있음',
    description: 'DAMAS 05 TAIL LAMP',
    fullDescription: 'Tail lamp compatible with Daewoo Damas 2005 models. Red lens ensures rear visibility.',
    compatibleVehicles: ['DAMAS 05'],
    voltage: '12V',
    partNumber: 'DMS05-003',
    image: 'https://readdy.ai/api/search-image?query=van%20tail%20lamp%20red%20lens%20compact%20design%20isolated%20on%20pure%20white%20background%20automotive%20lighting%20spare%20part%20catalog%20photography%20professional%20studio%20lighting&width=800&height=1000&seq=dms05003prod&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=red%20tail%20light%20compact%20van%20on%20white%20background%20automotive%20catalog%20photography&width=800&height=1000&seq=dms05003img1&orientation=portrait',
    ],
    colors: ['#FF0000'],
    features: [
      { icon: 'ri-lightbulb-line', title: 'Clear Tail Light', description: 'Rear visibility secured' },
      { icon: 'ri-shield-check-line', title: 'OEM Spec', description: 'Perfect fit' },
      { icon: 'ri-eye-line', title: 'Safety Light', description: 'Night safety ensured' },
      { icon: 'ri-tools-line', title: 'Easy Install', description: 'Bolt-on mounting' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=automotive%20tail%20lamp%20quality%20testing%20clean%20facility%20professional%20lighting&width=1200&height=900&seq=dms05003craft&orientation=landscape',
      story: 'High-quality tail lamp for rear safety of Damas 05 vehicles.',
      details: ['Red lens', 'OEM spec compliant', 'Waterproof treated', 'Enhanced durability'],
    },
  },
  // DAMAS 98
  {
    id: 2010,
    name: 'DMS98-001A',
    category: 'DAEWOO',
    subcategory: 'Lamp',
    price: 48000,
    status: '재고있음',
    description: 'DAMAS 98 HEAD LAMP',
    fullDescription: 'Head lamp compatible with Daewoo Damas 1998 models. Part No. L:35300-60C00. Manufactured to OEM specifications.',
    compatibleVehicles: ['DAMAS 98'],
    voltage: '12V',
    partNumber: 'L:35300-60C00',
    image: 'https://readdy.ai/api/search-image?query=vintage%20van%20headlamp%20clear%20glass%20lens%20chrome%20reflector%20rectangular%20isolated%20on%20pure%20white%20background%20automotive%20lighting%20spare%20part%20catalog%20photography%20professional%20studio%20lighting&width=800&height=1000&seq=dms98001aprod&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=classic%20van%20headlight%20clear%20lens%20on%20white%20background%20automotive%20catalog%20photography&width=800&height=1000&seq=dms98001aimg1&orientation=portrait',
    ],
    colors: ['#FFFFFF'],
    features: [
      { icon: 'ri-lightbulb-line', title: 'Clear Lighting', description: 'Night visibility enhanced' },
      { icon: 'ri-shield-check-line', title: 'OEM Spec', description: 'Perfect compatibility' },
      { icon: 'ri-water-flash-line', title: 'Waterproof', description: 'Rain-safe design' },
      { icon: 'ri-tools-line', title: 'Easy Install', description: 'Bolt-on mounting' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=automotive%20lighting%20quality%20control%20clean%20facility%20professional%20lighting&width=1200&height=900&seq=dms98001acraft&orientation=landscape',
      story: 'Head lamp for safe night driving of Damas 98 vehicles.',
      details: ['OEM specification', 'High-brightness lighting', 'Durable lens', 'Waterproof treated'],
    },
  },
  {
    id: 2011,
    name: 'DMS98-002B',
    category: 'DAEWOO',
    subcategory: 'Lamp',
    price: 25000,
    status: '재고있음',
    description: 'DAMAS 98 FRONT LAMP',
    fullDescription: 'Front lamp compatible with Daewoo Damas 1998 models. Part No. R:35602-70B00-000 / L:35601-70B00-000.',
    compatibleVehicles: ['DAMAS 98'],
    voltage: '12V',
    partNumber: 'R:35602-70B00-000 / L:35601-70B00-000',
    image: 'https://readdy.ai/api/search-image?query=van%20front%20indicator%20lamp%20amber%20orange%20lens%20isolated%20on%20pure%20white%20background%20automotive%20lighting%20spare%20part%20catalog%20photography%20professional%20studio%20lighting&width=800&height=1000&seq=dms98002bprod&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=amber%20front%20signal%20lamp%20van%20on%20white%20background%20automotive%20catalog%20photography&width=800&height=1000&seq=dms98002bimg1&orientation=portrait',
    ],
    colors: ['#FFD700'],
    features: [
      { icon: 'ri-lightbulb-line', title: 'Clear Signal', description: 'Safe turn indication' },
      { icon: 'ri-shield-check-line', title: 'OEM Spec', description: 'Perfect fit' },
      { icon: 'ri-eye-line', title: 'High Visibility', description: 'Day & night clear' },
      { icon: 'ri-tools-line', title: 'Easy Install', description: 'Bolt-on mounting' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=automotive%20signal%20lamp%20production%20clean%20factory%20professional%20lighting&width=1200&height=900&seq=dms98002bcraft&orientation=landscape',
      story: 'Front lamp for safe turning of Damas 98 vehicles.',
      details: ['High-brightness amber lens', 'OEM spec match', 'Fast blink response', 'Durability guaranteed'],
    },
  },
  {
    id: 2012,
    name: 'DMS98-003A',
    category: 'DAEWOO',
    subcategory: 'Lamp',
    price: 32000,
    status: '재고있음',
    description: 'DAMAS 98 TAIL LAMP',
    fullDescription: 'Tail lamp compatible with Daewoo Damas 1998 models. Part No. R:35604-85500 / L:35603-85500.',
    compatibleVehicles: ['DAMAS 98'],
    voltage: '12V',
    partNumber: 'R:35604-85500 / L:35603-85500',
    image: 'https://readdy.ai/api/search-image?query=van%20tail%20lamp%20red%20and%20amber%20lens%20combination%20isolated%20on%20pure%20white%20background%20automotive%20lighting%20spare%20part%20catalog%20photography%20professional%20studio%20lighting&width=800&height=1000&seq=dms98003aprod&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=red%20amber%20tail%20light%20van%20on%20white%20background%20automotive%20catalog%20photography&width=800&height=1000&seq=dms98003aimg1&orientation=portrait',
    ],
    colors: ['#FF0000'],
    features: [
      { icon: 'ri-lightbulb-line', title: 'Clear Tail Light', description: 'Rear visibility secured' },
      { icon: 'ri-shield-check-line', title: 'OEM Spec', description: 'Perfect fit' },
      { icon: 'ri-eye-line', title: 'Safety Light', description: 'Night safety ensured' },
      { icon: 'ri-tools-line', title: 'Easy Install', description: 'Bolt-on mounting' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=automotive%20tail%20lamp%20quality%20testing%20clean%20facility%20professional%20lighting&width=1200&height=900&seq=dms98003acraft&orientation=landscape',
      story: 'High-quality tail lamp for rear safety of Damas 98 vehicles.',
      details: ['Red/amber combo lens', 'OEM spec compliant', 'Waterproof treated', 'Enhanced durability'],
    },
  },
  {
    id: 2013,
    name: 'DMS98-004B',
    category: 'DAEWOO',
    subcategory: 'Lamp',
    price: 30000,
    status: '재고있음',
    description: 'DAMAS 98 TAIL LAMP (SIDE)',
    fullDescription: 'Side tail lamp compatible with Daewoo Damas 1998 models. Red lens ensures side visibility.',
    compatibleVehicles: ['DAMAS 98'],
    voltage: '12V',
    partNumber: 'DMS98-004B',
    image: 'https://readdy.ai/api/search-image?query=van%20side%20marker%20lamp%20red%20lens%20rectangular%20small%20isolated%20on%20pure%20white%20background%20automotive%20lighting%20spare%20part%20catalog%20photography%20professional%20studio%20lighting&width=800&height=1000&seq=dms98004bprod&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=red%20side%20marker%20light%20van%20on%20white%20background%20automotive%20catalog%20photography&width=800&height=1000&seq=dms98004bimg1&orientation=portrait',
    ],
    colors: ['#FF0000'],
    features: [
      { icon: 'ri-lightbulb-line', title: 'Side Visibility', description: 'Side safety secured' },
      { icon: 'ri-shield-check-line', title: 'OEM Spec', description: 'Perfect fit' },
      { icon: 'ri-eye-line', title: 'Clear Lighting', description: 'Night safety' },
      { icon: 'ri-tools-line', title: 'Easy Install', description: 'Bolt-on mounting' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=automotive%20side%20lamp%20production%20clean%20factory%20professional%20lighting&width=1200&height=900&seq=dms98004bcraft&orientation=landscape',
      story: 'Side tail lamp for side safety of Damas 98 vehicles.',
      details: ['Red lens', 'OEM spec match', 'Waterproof treated', 'Durability guaranteed'],
    },
  },
  {
    id: 2014,
    name: 'DMS98-005A',
    category: 'DAEWOO',
    subcategory: 'Exterior',
    price: 22000,
    status: '재고있음',
    description: 'DAMAS 98 GRILLE (GRAY)',
    fullDescription: 'Front grille compatible with Daewoo Damas 1998 models. Gray color maintains OEM style.',
    compatibleVehicles: ['DAMAS 98'],
    voltage: '-',
    partNumber: 'DMS98-005A',
    image: 'https://readdy.ai/api/search-image?query=van%20front%20grille%20gray%20plastic%20rectangular%20with%20horizontal%20slats%20isolated%20on%20pure%20white%20background%20automotive%20exterior%20spare%20part%20catalog%20photography%20professional%20studio%20lighting&width=800&height=1000&seq=dms98005aprod&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=gray%20van%20front%20grille%20on%20white%20background%20automotive%20catalog%20photography&width=800&height=1000&seq=dms98005aimg1&orientation=portrait',
    ],
    colors: ['#808080'],
    features: [
      { icon: 'ri-car-line', title: 'OEM Design', description: 'Original style' },
      { icon: 'ri-shield-check-line', title: 'OEM Spec', description: 'Perfect fit' },
      { icon: 'ri-sun-line', title: 'UV Resistant', description: 'Anti-discoloration' },
      { icon: 'ri-tools-line', title: 'Easy Install', description: 'Clip mounting' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=automotive%20grille%20manufacturing%20clean%20facility%20professional%20lighting&width=1200&height=900&seq=dms98005acraft&orientation=landscape',
      story: 'OEM grille to restore the front appearance of Damas 98 vehicles.',
      details: ['OEM gray color', 'High-strength plastic', 'UV coating treated', 'Precise specification'],
    },
  },
  {
    id: 2015,
    name: 'DMS98-006B',
    category: 'DAEWOO',
    subcategory: 'Exterior',
    price: 22000,
    status: '재고있음',
    description: 'DAMAS 98 GRILLE (BLACK)',
    fullDescription: 'Front grille compatible with Daewoo Damas 1998 models. Black color for sporty styling.',
    compatibleVehicles: ['DAMAS 98'],
    voltage: '-',
    partNumber: 'DMS98-006B',
    image: 'https://readdy.ai/api/search-image?query=van%20front%20grille%20black%20plastic%20rectangular%20with%20horizontal%20slats%20sporty%20isolated%20on%20pure%20white%20background%20automotive%20exterior%20spare%20part%20catalog%20photography%20professional%20studio%20lighting&width=800&height=1000&seq=dms98006bprod&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=black%20van%20front%20grille%20on%20white%20background%20automotive%20catalog%20photography&width=800&height=1000&seq=dms98006bimg1&orientation=portrait',
    ],
    colors: ['#000000'],
    features: [
      { icon: 'ri-car-line', title: 'Sporty Design', description: 'Black style' },
      { icon: 'ri-shield-check-line', title: 'OEM Spec', description: 'Perfect fit' },
      { icon: 'ri-sun-line', title: 'UV Resistant', description: 'Anti-discoloration' },
      { icon: 'ri-tools-line', title: 'Easy Install', description: 'Clip mounting' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=automotive%20exterior%20parts%20production%20clean%20factory%20professional%20lighting&width=1200&height=900&seq=dms98006bcraft&orientation=landscape',
      story: 'Black grille that adds a sporty feel to Damas 98 vehicles.',
      details: ['Black color finish', 'High-strength plastic', 'UV coating', 'Precise specification'],
    },
  },
  {
    id: 2016,
    name: 'DMS98-007C',
    category: 'DAEWOO',
    subcategory: 'Exterior',
    price: 22000,
    status: '재고있음',
    description: 'DAMAS 98 GRILLE (BLUE)',
    fullDescription: 'Front grille compatible with Daewoo Damas 1998 models. Blue color for unique styling.',
    compatibleVehicles: ['DAMAS 98'],
    voltage: '-',
    partNumber: 'DMS98-007C',
    image: 'https://readdy.ai/api/search-image?query=van%20front%20grille%20dark%20blue%20plastic%20rectangular%20with%20horizontal%20slats%20isolated%20on%20pure%20white%20background%20automotive%20exterior%20spare%20part%20catalog%20photography%20professional%20studio%20lighting&width=800&height=1000&seq=dms98007cprod&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=blue%20van%20front%20grille%20on%20white%20background%20automotive%20catalog%20photography&width=800&height=1000&seq=dms98007cimg1&orientation=portrait',
    ],
    colors: ['#00008B'],
    features: [
      { icon: 'ri-car-line', title: 'Blue Design', description: 'Unique style' },
      { icon: 'ri-shield-check-line', title: 'OEM Spec', description: 'Perfect fit' },
      { icon: 'ri-sun-line', title: 'UV Resistant', description: 'Anti-discoloration' },
      { icon: 'ri-tools-line', title: 'Easy Install', description: 'Clip mounting' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=automotive%20grille%20color%20finishing%20clean%20facility%20professional%20lighting&width=1200&height=900&seq=dms98007ccraft&orientation=landscape',
      story: 'Blue grille that adds personality to Damas 98 vehicles.',
      details: ['Blue color finish', 'High-strength plastic', 'UV coating', 'Precise specification'],
    },
  },
  // MATIZ 01
  {
    id: 2017,
    name: 'MTZ01-001',
    category: 'DAEWOO',
    subcategory: 'Lamp',
    price: 52000,
    status: '재고있음',
    description: 'MATIZ 01 FRONT LAMP',
    fullDescription: 'Front lamp compatible with Daewoo Matiz 2001 models. Part No. L:96563486 / R:96563487. Manufactured to OEM specifications.',
    compatibleVehicles: ['MATIZ 01'],
    voltage: '12V',
    partNumber: 'L:96563486 / R:96563487',
    image: 'https://readdy.ai/api/search-image?query=compact%20car%20front%20headlamp%20clear%20lens%20round%20design%20modern%20isolated%20on%20pure%20white%20background%20automotive%20lighting%20spare%20part%20catalog%20photography%20professional%20studio%20lighting&width=800&height=1000&seq=mtz01001prod&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=small%20car%20headlight%20round%20clear%20lens%20on%20white%20background%20automotive%20catalog%20photography&width=800&height=1000&seq=mtz01001img1&orientation=portrait',
    ],
    colors: ['#FFFFFF'],
    features: [
      { icon: 'ri-lightbulb-line', title: 'Clear Lighting', description: 'Night visibility enhanced' },
      { icon: 'ri-shield-check-line', title: 'OEM Spec', description: 'Perfect compatibility' },
      { icon: 'ri-water-flash-line', title: 'Waterproof', description: 'Rain-safe design' },
      { icon: 'ri-tools-line', title: 'Easy Install', description: 'Bolt-on mounting' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=automotive%20headlamp%20assembly%20line%20clean%20factory%20professional%20lighting&width=1200&height=900&seq=mtz01001craft&orientation=landscape',
      story: 'High-quality front lamp for safe night driving of Matiz 01 vehicles.',
      details: ['OEM specification', 'High-brightness lighting', 'Durable lens', 'Waterproof treated'],
    },
  },
  {
    id: 2018,
    name: 'MTZ01-002B',
    category: 'DAEWOO',
    subcategory: 'Lamp',
    price: 38000,
    status: '재고있음',
    description: 'MATIZ 01 TAIL LAMP (LH WHITE)',
    fullDescription: 'Tail lamp compatible with Daewoo Matiz 2001 models. Part No. R:96563515 / L:96563514. LH white type.',
    compatibleVehicles: ['MATIZ 01'],
    voltage: '12V',
    partNumber: 'R:96563515 / L:96563514',
    image: 'https://readdy.ai/api/search-image?query=compact%20car%20tail%20lamp%20red%20and%20white%20lens%20combination%20modern%20isolated%20on%20pure%20white%20background%20automotive%20lighting%20spare%20part%20catalog%20photography%20professional%20studio%20lighting&width=800&height=1000&seq=mtz01002bprod&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=small%20car%20tail%20light%20red%20white%20on%20white%20background%20automotive%20catalog%20photography&width=800&height=1000&seq=mtz01002bimg1&orientation=portrait',
    ],
    colors: ['#FFFFFF'],
    features: [
      { icon: 'ri-lightbulb-line', title: 'Clear Tail Light', description: 'Rear visibility secured' },
      { icon: 'ri-shield-check-line', title: 'OEM Spec', description: 'Perfect fit' },
      { icon: 'ri-eye-line', title: 'Safety Light', description: 'Night safety ensured' },
      { icon: 'ri-tools-line', title: 'Easy Install', description: 'Bolt-on mounting' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=automotive%20tail%20lamp%20quality%20testing%20clean%20facility%20professional%20lighting&width=1200&height=900&seq=mtz01002bcraft&orientation=landscape',
      story: 'High-quality tail lamp for rear safety of Matiz 01 vehicles.',
      details: ['Red/white combo lens', 'OEM spec compliant', 'Waterproof treated', 'Enhanced durability'],
    },
  },
  // LEGANZA 97
  {
    id: 2019,
    name: 'LAA97-001',
    category: 'DAEWOO',
    subcategory: 'Lamp',
    price: 55000,
    status: '재고있음',
    description: 'LEGANZA 97 FRONT LAMP',
    fullDescription: 'Front lamp compatible with Daewoo Leganza 1997 models. Part No. R:96206627 / L:96206626. Manufactured to OEM specifications.',
    compatibleVehicles: ['LEGANZA 97'],
    voltage: '12V',
    partNumber: 'R:96206627 / L:96206626',
    image: 'https://readdy.ai/api/search-image?query=sedan%20front%20turn%20signal%20lamp%20amber%20lens%20sleek%20design%20isolated%20on%20pure%20white%20background%20automotive%20lighting%20spare%20part%20catalog%20photography%20professional%20studio%20lighting&width=800&height=1000&seq=laa97001prod&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=sedan%20front%20indicator%20light%20amber%20on%20white%20background%20automotive%20catalog%20photography&width=800&height=1000&seq=laa97001img1&orientation=portrait',
    ],
    colors: ['#FFD700'],
    features: [
      { icon: 'ri-lightbulb-line', title: 'Clear Signal', description: 'Safe turn indication' },
      { icon: 'ri-shield-check-line', title: 'OEM Spec', description: 'Perfect fit' },
      { icon: 'ri-eye-line', title: 'High Visibility', description: 'Day & night clear' },
      { icon: 'ri-tools-line', title: 'Easy Install', description: 'Bolt-on mounting' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=automotive%20signal%20lamp%20production%20clean%20factory%20professional%20lighting&width=1200&height=900&seq=laa97001craft&orientation=landscape',
      story: 'High-quality front lamp for safe turning of Leganza 97 vehicles.',
      details: ['High-brightness amber lens', 'OEM spec match', 'Fast blink response', 'Durability guaranteed'],
    },
  },
];
